// Container imports
const {
  DOWNLOAD_SELECT,
  HIDE,
  SHOW,
  SUBMIT_FAILED,
  SUBMIT_SUCCESS
} = require('./actions')
const SMSModalRecord = require('./record')

function smsModalReducer(state, { type, payload }) {
  const isDownloadPromptVisible = payload ? payload.isDownloadPromptVisible : false
  switch (type) {
    case SHOW:
      return new SMSModalRecord({
        isVisible: true,
        isDownloadPromptVisible
      })
    case DOWNLOAD_SELECT:
      return state.merge({
        isDownloadPromptVisible: false
      })
    case HIDE:
      return null
    case SUBMIT_FAILED:
      return state.merge({
        isSubmitFailed: true
      })
    case SUBMIT_SUCCESS:
      return state.merge({
        isSubmitSuccessful: true
      })
    default:
      return state
  }
}

module.exports = smsModalReducer
